import { jsx as t, jsxs as o } from "react/jsx-runtime";
import { sizes as n } from "@smart/web-foundations";
import { c as m } from "./chunks/index.rKuIKazb.js";
import i from "react";
import './assets/spinner.css';const h = "_spinner_1ever_2", u = "_asset_1ever_6", _ = "_rotate_1ever_1", e = {
  spinner: h,
  asset: u,
  rotate: _
}, v = i.forwardRef(
  ({ size: s = "xl", className: a, children: p, loading: c = !0, ...l }, d) => {
    const r = i.useId(), f = m(e.spinner, e[s], a);
    return c ? /* @__PURE__ */ t(
      "div",
      {
        className: f,
        role: "status",
        "aria-live": "polite",
        ref: d,
        ...l,
        children: /* @__PURE__ */ o(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 80 80",
            fill: "none",
            className: e.asset,
            height: n[s],
            width: n[s],
            children: [
              /* @__PURE__ */ o("g", { strokeWidth: "8", children: [
                /* @__PURE__ */ t("path", { d: " M 4 40 A 36 36 0 0 1 76 40", stroke: `url(#${r}-top)` }),
                /* @__PURE__ */ t(
                  "path",
                  {
                    d: " M 76 40 A 36 36 180 0 1 4 40",
                    stroke: `url(#${r}-bottom)`
                  }
                ),
                /* @__PURE__ */ t(
                  "path",
                  {
                    d: " M 4 40 A 36 36 180 0 1 5 33",
                    stroke: "var(--ds-accent)",
                    strokeLinecap: "round"
                  }
                )
              ] }),
              /* @__PURE__ */ o("defs", { children: [
                /* @__PURE__ */ o("linearGradient", { id: `${r}-top`, children: [
                  /* @__PURE__ */ t("stop", { offset: "0%", stopOpacity: "0", stopColor: "currentColor" }),
                  /* @__PURE__ */ t("stop", { offset: "100%", stopOpacity: "0.5", stopColor: "currentColor" })
                ] }),
                /* @__PURE__ */ o("linearGradient", { id: `${r}-bottom`, children: [
                  /* @__PURE__ */ t("stop", { offset: "0%", stopOpacity: "1", stopColor: "currentColor" }),
                  /* @__PURE__ */ t("stop", { offset: "100%", stopOpacity: "0.5", stopColor: "currentColor" })
                ] })
              ] })
            ]
          }
        )
      }
    ) : p;
  }
);
v.displayName = "Spinner";
export {
  v as Spinner
};
//# sourceMappingURL=spinner.js.map
